export default "__VITE_ASSET__Msg57USEadASvSStYSdmzA__ 240w, __VITE_ASSET__epdbhdyBUyD3hvxx0_dcTg__ 480w";